"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notifications = exports.NotificationConfirmOptions = exports.NotificationOptions = void 0;
const NotificationTemplates_1 = require("./NotificationTemplates");
const Utilities_1 = require("./Utilities");
/**
 * Options for displaying a notification
 */
class NotificationOptions {
}
exports.NotificationOptions = NotificationOptions;
/**
 * Options for displaying a notification that awaits a confirmation
 */
class NotificationConfirmOptions extends NotificationOptions {
}
exports.NotificationConfirmOptions = NotificationConfirmOptions;
class Notifications {
    constructor() {
        // Maps notification GUID to setTimeout id
        this.m_delayedNotificationTimers = {};
    }
    /**
     * Displays an "info" notification
     * @param content Either string or JQuery containing HTML
     * @param options Notification options
     * @returns Guid of the created notification
     */
    info(content, options) {
        return this.showNotificationCore(content, "info", options);
    }
    /**
     * Displays an "success" notification
     * @param content Either string or JQuery containing HTML
     * @param options Notification options
     * @returns Guid of the created notification
     */
    success(content, options) {
        return this.showNotificationCore(content, "success", options);
    }
    /**
   * Displays an "menuSuccess" notification
   * @param functionName Internal name (e.g. "cefunc.2") of the menu entry that succeeded
   * @param options Notification options
   * @returns Guid of the created notification
   */
    menuSuccess(functionName, options) {
        let text = kendo.format(Utilities_1.synUtil.Strings.getValue("menusuccess"), Utilities_1.synUtil.Strings.getValue(functionName));
        return this.showNotificationCore(text, "success", options);
    }
    /**
    * Displays an "waiting" notification, which willl not autohide, but must be removed
    * manually.
    * @param text Text to display
    * @param options Notification options. autoHideAfter and hideOnClick are ignored.
    * @returns Guid of the created notification
    */
    waiting(text, options) {
        let fixedOptions = $.extend({}, options, { autoHideAfter: 0, hideOnClick: false });
        return this.showNotificationCore(text, "waiting", fixedOptions);
    }
    /**
     * Displays a "warning" notification
     * @param content Either string or JQuery containing HTML
     * @param options Notification options
     * @returns Guid of the created notification
     */
    warning(content, options) {
        return this.showNotificationCore(content, "warning", options);
    }
    /**
     * Displays a "warning" notification which prompts the user for cofirmation (OK, Cancel)
     * @param content Either string or JQuery containing HTML
     * @param options Notification confirmation options
     * @returns NotificationConfirmResult containing guid of the created notification and a promise that
     * resolves with true if the user clicks OK, and false if the user clicks Cancel.
     */
    warningConfirm(content, options) {
        let showOkButton = !options || options.okButton || !options.okButton && !options.cancelButton;
        let showCancelButton = options === null || options === void 0 ? void 0 : options.cancelButton;
        let $notificationDiv = $("<div></div>");
        let $wrapper = $("<span style='display: block'></span>").appendTo($notificationDiv);
        if (typeof content === "string")
            $wrapper.text(Utilities_1.synUtil.Strings.getValue("syndocumentchangedwhileediting"));
        else if (typeof content !== "undefined")
            $wrapper.append(content);
        let $buttonWrapper = $("<div></div>")
            .css({
            "width": "100%",
            "margin-top": "10px",
            "display": "flex"
        })
            .appendTo($notificationDiv);
        let $okButton = $();
        let $cancelButton = $();
        if (showOkButton)
            $okButton = $("<button type='button' class='btn btn-success'></button>")
                .css({ "flex": "1" })
                .text(Utilities_1.synUtil.Strings.getValue("menuok"))
                .appendTo($buttonWrapper);
        if (showCancelButton)
            $cancelButton = $("<button type='button' class='btn'></button>")
                .css({ "flex": "1" })
                .text(Utilities_1.synUtil.Strings.getValue("menuok"))
                .appendTo($buttonWrapper);
        let guid = Utilities_1.synUtil.Notifications.warning($notificationDiv, { autoHideAfter: 0 });
        return {
            notificationGuid: guid,
            confirmResult: new Promise((resolve, reject) => {
                $okButton.on("click", () => { Utilities_1.synUtil.Notifications.remove(guid); resolve(true); });
                $cancelButton.on("click", () => { Utilities_1.synUtil.Notifications.remove(guid); resolve(false); });
            })
        };
    }
    /**
     * Displays an "error" notification
     * @param content Either string or JQuery containing HTML
     * @param options Notification options
     * @returns Guid of the created notification
     */
    error(content, options) {
        return this.showNotificationCore(content, "error", options);
    }
    /**
     * Attempts to remove a notification by GUID
     * @param guid GUID of the notification to remove
     * @returns true if removal was successful, else false
     */
    remove(guid) {
        let delayedTimerId = this.m_delayedNotificationTimers[guid];
        if (delayedTimerId) {
            window.clearTimeout(delayedTimerId);
            delete this.m_delayedNotificationTimers[guid];
        }
        let notificationApi = Notifications.resolveNotificationApi(guid);
        if (!notificationApi)
            return false;
        let $notifications = notificationApi.getNotifications();
        // Prefer the standard way of hiding when the container has only 1 active notification,
        // as this way includes the animation
        if ($notifications.length === 1) {
            notificationApi.hide();
            return true;
        }
        else {
            this.getNotificationElem(guid).parent().remove();
            let guids = notificationApi.element.data("guids");
            guids.splice(guids.indexOf(guid), 1);
            Notifications.hideEmptyContainer(notificationApi.element);
            return true;
        }
    }
    static resolveNotificationApi(guid) {
        let result;
        if (guid) {
            $(".synNotyContainer").each((idx, elem) => {
                let $container = $(elem);
                let guids = $container.data("guids");
                if ($.isArray(guids) && guids.indexOf(guid) >= 0)
                    result = $container.data("kendoNotification") || undefined;
            });
        }
        return result;
    }
    /**
     * Attempts to locate the notification popup for the given GUID and returns it. Returns an
     * empty JQuery selector if not found.
     * @param guid GUID for the notification popup to locate.
     * @returns JQuery object for the found notification, or empty JQuery selector, if not found.
     */
    getNotificationElem(guid) {
        let $result = $();
        let notificationApi = Notifications.resolveNotificationApi(guid);
        if (notificationApi) {
            notificationApi.getNotifications().each((idx, elem) => {
                let $elem = $(elem);
                if (guid === $elem.children(".synNotification").attr("data-notificationguid")) {
                    $result = $elem;
                    return false;
                }
            });
        }
        return $result;
    }
    static onHideNotification(e) {
        let guid = e.element.children(".synNotification").attr("data-notificationguid");
        let notificationApi = Notifications.resolveNotificationApi(guid);
        let guids = notificationApi.element.data("guids");
        guids.splice(guids.indexOf(guid), 1);
        Notifications.hideEmptyContainer(notificationApi.element);
    }
    static hideEmptyContainer($container) {
        if ($container.data("guids").length === 0) {
            let api = $container.data("kendoNotification");
            if (api)
                api.destroy();
            $container.remove();
        }
    }
    getSelectorForContainer(type, options) {
        let selector = ".synNotyContainer";
        let centered = type === "error" || type === "waiting";
        if (options) {
            if (options.forceCenter)
                centered = true;
            if (typeof options.autoHideAfter !== "undefined")
                selector += "[data-autohideafter='" + options.autoHideAfter.toString() + "']";
            else
                selector += "[data-autohideafter='undefined']";
            if (options.hideOnClick === false)
                selector += "[data-nohideonclick='true']";
            else
                selector += "[data-nohideonclick='false']";
            if (options.showAfter)
                selector += "[data-showafter='" + options.showAfter.toString() + "']";
            else
                selector += "[data-showafter='undefined']";
        }
        else
            selector += "[data-showafter='undefined'][data-nohideonclick='false'][data-autohideafter='undefined']";
        if (centered)
            selector += ".notificationCentered";
        else
            selector += ".notification";
        return selector;
    }
    ensureContainer(type, options) {
        let $selector = $(this.getSelectorForContainer(type, options));
        if (!$selector.length) {
            $selector = $("<span></span>").data("guids", []).addClass("synNotyContainer");
            let centered = type === "error" || type === "waiting";
            let notificationOpts = $.extend({}, Notifications.m_kendoDefaultOptions);
            if (options) {
                if (options.forceCenter)
                    centered = true;
                if (typeof options.autoHideAfter !== "undefined") {
                    $selector.attr("data-autohideafter", options.autoHideAfter.toString());
                    notificationOpts.autoHideAfter = options.autoHideAfter;
                }
                else
                    $selector.attr("data-autohideafter", "undefined");
                if (options.showAfter) {
                    $selector.attr("data-showafter", options.showAfter.toString());
                    if (notificationOpts.autoHideAfter > 0)
                        notificationOpts.autoHideAfter += options.showAfter;
                }
                else
                    $selector.attr("data-showafter", "undefined");
                if (options.hideOnClick === false) {
                    $selector.attr("data-nohideonclick", "true");
                    notificationOpts.hideOnClick = false;
                }
                else
                    $selector.attr("data-nohideonclick", "false");
            }
            else {
                $selector.attr({
                    "data-showafter": "undefined",
                    "data-nohideonclick": "false",
                    "data-autohideafter": "undefined"
                });
            }
            if (centered) {
                $selector.addClass("notificationCentered");
                notificationOpts = $.extend(notificationOpts, Notifications.m_kendoCenteredOptions);
            }
            else
                $selector.addClass("notification");
            notificationOpts.hide = Notifications.onHideNotification;
            notificationOpts.show = ((e) => {
                if (centered) {
                    if (!$("." + e.sender._guid)[1]) {
                        let element = e.element.parent(), eWidth = element.width(), eHeight = element.height(), wWidth = $(window).width(), wHeight = $(window).height(), newTop, newLeft;
                        newLeft = Math.floor(wWidth / 2 - eWidth / 2);
                        newTop = Math.floor(wHeight / 2 - eHeight / 2);
                        e.element.parent().css({ top: newTop, left: newLeft, zIndex: 22222 });
                    }
                }
                let guid = e.element.children(".synNotification").attr("data-notificationguid");
                let guids = $selector.data("guids");
                guids.push(guid);
            });
            $selector.kendoNotification(notificationOpts);
            return $selector.appendTo($("body"));
        }
        return $selector;
    }
    showNotificationCore(content, type, options) {
        let that = this;
        let guid = Utilities_1.synUtil.getGUID(true);
        let $container = that.ensureContainer(type, options);
        if ((options === null || options === void 0 ? void 0 : options.showAfter) && options.showAfter > 0)
            that.m_delayedNotificationTimers[guid] = window.setTimeout(() => {
                that.show(guid, $container, content, type);
                delete that.m_delayedNotificationTimers[guid];
            }, options.showAfter);
        else
            that.show(guid, $container, content, type);
        return guid;
    }
    show(guid, $notificationContainer, content, type) {
        let notificationApi = $notificationContainer.data("kendoNotification");
        if (typeof content === "string")
            notificationApi.show({ text: content.replace(/\r?\n/g, "<br />"), guid }, type);
        else {
            notificationApi.show({ text: "", guid }, type);
            this.getNotificationElem(guid).children(".synNotification").html("").append(content);
        }
    }
}
exports.Notifications = Notifications;
Notifications.m_kendoDefaultOptions = {
    stacking: "up",
    animation: {
        open: { effects: "slideIn:left" },
        close: { effects: "slideIn:left", reverse: true }
    },
    hideOnClick: true,
    autoHideAfter: 5000,
    position: { bottom: 20, right: 20 },
    width: 300,
    templates: [
        { type: "info", template: NotificationTemplates_1.InfoTemplate },
        { type: "success", template: NotificationTemplates_1.SuccessTemplate },
        { type: "warning", template: NotificationTemplates_1.WarningTemplate },
        { type: "error", template: NotificationTemplates_1.ErrorTemplate },
        { type: "waiting", template: NotificationTemplates_1.WaitingTemplate }
    ]
};
Notifications.m_kendoCenteredOptions = {
    stacking: "down",
    animation: {
        open: { effects: "fade:in" },
        close: { effects: "fade:out" }
    },
    button: true
};
